const PLAN_CATEGORIES = ["free", "growth", "premium"]

function hasPlans(product: any) {
    return product?.prices?.some((price: any) => PLAN_CATEGORIES.includes(price?.metadata?.category)) || false
}

/**
 * The pricing page reads products[0]. A partner's Stripe account can also hold products without
 * plans (such as Cakemail Email API), which would leave the page empty, so the first product
 * with free, growth or premium prices goes first. The others keep their order.
 */
export function subscriptionProductFirst<T>(products: T[] | undefined): T[] {
    if (!Array.isArray(products)) return []
    const index = products.findIndex(hasPlans)
    if (index <= 0) return products
    return [products[index], ...products.slice(0, index), ...products.slice(index + 1)]
}
